// Grandeur Nature : menu téléphone et galerie produit. Tout fonctionne aussi sans JavaScript.
document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.getElementById('menu-mobile');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
  }

  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('.gallery-main img');
    if (!main) return;
    gallery.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.dataset.src;
        main.srcset = btn.dataset.srcset || '';
        main.alt = btn.dataset.alt || '';
        gallery.querySelectorAll('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
  });

  // Variante choisie : mettre à jour le prix et le bouton.
  var select = document.querySelector('[data-variant-select]');
  if (select) {
    var price = document.querySelector('[data-product-price]');
    var add = document.querySelector('[data-add-button]');
    var update = function () {
      var opt = select.options[select.selectedIndex];
      if (price && opt.dataset.price) price.innerHTML = opt.dataset.price;
      if (add) {
        var available = opt.dataset.available === 'true';
        add.disabled = !available;
        add.textContent = available ? add.dataset.labelAdd : add.dataset.labelSold;
      }
    };
    select.addEventListener('change', update);
  }
});
